module.exports = __webpack_public_path__ + "static/media/practice.721430e6.svg";